module.exports = __webpack_public_path__ + "img/PD1503919454751428608.03a6325a.png";